// src/pages/Centers/components/CenterEdit.tsx
import React, { useContext, useEffect, useState } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { AppContext } from '../../../contexts/AppContext';
import { toast } from 'react-toastify';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import useCenterService from '../../../app/services/hooks/useCenterService';
import { CenterDataForm } from '../../../app/models/Center';
import CenterFormContainer from './CenterFormContainer';

type SelectOpt = { id: number | string; name: string };

interface Props {
  centerId: number;
  onSaved?: () => void;
  onCancel?: () => void;
  onError?: () => void;
}

const NOOP = () => undefined;

const toCenterDataForm = (c: any): CenterDataForm => ({
  
  society_id: c?.society_id ?? undefined,
  name: c?.name ?? '',
  address: c?.address ?? '',
  is_active: typeof c?.is_active === 'boolean' ? c.is_active : true,
});

const CenterEdit = ({ centerId, onSaved, onCancel = NOOP, onError }: Props) => {
  const { showLoading, hideLoading } = useContext(AppContext);
  const { editCenter, updateCenter, fetchingEditCenter, fetchingUpdateCenter } = useCenterService();

  const [center, setCenter] = useState<CenterDataForm>({
    society_id: undefined,
    name: '',
    address: '',
    is_active: true,
  });

  const [societies, setSocieties] = useState<SelectOpt[]>([]);

  const [errorFields, setErrorFields] = useState<any>();

  useEffect(() => {
    edit();
  }, [centerId]);

  const edit = () => {
    showLoading?.('loading', 'Cargando centro...');
    editCenter(centerId, {
      onSuccess: (response: ServiceResponse) => {
        const { center: centerPayload, societies: societiesPayload } = response.data || {};

        setCenter(toCenterDataForm(centerPayload));
        setSocieties(Array.isArray(societiesPayload) ? societiesPayload : []);

        setErrorFields(undefined);
        hideLoading?.();
      },
      onError: (response: ServiceResponse) => {
        hideLoading?.();
        toast.error(response.message);
        onError && onError();
      },
    });
  };

  const update = () => {
    showLoading?.('loading', 'Actualizando centro...');
    const payload = {
      society_id: center.society_id,
      name: center.name?.trim(),
      address: center.address?.trim(),
      is_active: center.is_active,
    };

    updateCenter(centerId, payload, {
      onSuccess: (response: ServiceResponse) => {
        hideLoading?.();
        useReactConfirmAlert().successAlert({ title: 'Éxito', message: response.message });
        onSaved && onSaved();
      },
      onError: (response: ServiceResponse) => {
        hideLoading?.();
        useReactConfirmAlert().errorAlert({ title: 'Error', message: response.message });
      },
      onFieldError: (errs: ServiceResponse) => {
        hideLoading?.();
        setErrorFields(errs.data);
      },
    });
  };

  return (
    <CenterFormContainer
      fetching={fetchingEditCenter || fetchingUpdateCenter}
      action={update}
      cancel={onCancel}
      center={center}
      setCenter={setCenter}
      errorFields={errorFields}
      societies={societies}
    />
  );
};

export default CenterEdit;
